import React from 'react';

import './ServerConnectionNotice.css';

export interface ServerConnectionNoticeProps {
    title: string;
    message: string;
}

export const ServerConnectionNotice = ({title, message}: ServerConnectionNoticeProps) => {
    return (
        <div className="ServerConnectionNotice body-medium" role="status" aria-live="polite">
            <span className="ServerConnectionNotice__title title-medium">
                {title}
            </span>
            <span className="ServerConnectionNotice__message">
                {message}
            </span>
        </div>
    );
};
